import type { FC, ReactNode } from "react";
import { PopupHoverContainer } from "@similarweb/ui-components";
import GAVerifiedTooltipContent from "./GAVerifiedTooltipContent";

interface IGAVerifiedTooltip {
    isEnabled: boolean;
    isActive: boolean;
    isPrivate: boolean;
    openTooltip: boolean;
    metric: string;
    onGAWizardModalOpen: () => void;
    children: ReactNode;
}

interface IGAVerifiedTooltipContentStrings {
    title: string;
    body: string;
    linkText: string;
}

function setContent(isActive, isPrivate) {
    const _content: IGAVerifiedTooltipContentStrings = {
        title: "",
        body: "",
        linkText: "",
    };
    //Tooltip content for not-verified website
    if (!isActive) {
        _content.title = "GAVerified.tooltip.disabled.title";
        _content.body = "GAVerified.tooltip.disabled.body";
        _content.linkText = "GAVerified.tooltip.disabled.linkText";
    }

    //Tooltip content for public website
    else if (isActive && !isPrivate) {
        _content.title = "GAVerified.tooltip.public.title";
        _content.body = "GAVerified.tooltip.public.body";
        _content.linkText = "GAVerified.tooltip.public.linkText";
    }

    //Tooltip content for private website
    else if (isActive && isPrivate) {
        _content.title = "GAVerified.tooltip.private.title";
        _content.body = "GAVerified.tooltip.private.body";
        _content.linkText = "GAVerified.tooltip.private.linkText";
    }

    return _content;
}

const GAVerifiedTooltip: FC<IGAVerifiedTooltip> = ({
    isEnabled,
    isActive,
    isPrivate,
    openTooltip,
    children,
    metric,
    onGAWizardModalOpen,
}) => {
    const _content = setContent(isActive, isPrivate);
    return (
        <PopupHoverContainer
            content={() => (
                <GAVerifiedTooltipContent
                    metric={metric}
                    openTooltip={openTooltip}
                    isPrivate={isPrivate}
                    isActive={isActive}
                    title={_content.title}
                    body={_content.body}
                    linkText={_content.linkText}
                    onGAWizardModalOpen={onGAWizardModalOpen}
                />
            )}
            injectClosePopupIntoContent={true}
            config={{
                enabled: isEnabled,
                defaultOpen: openTooltip,
                placement: "bottom",
                allowHover: true,
            }}
        >
            {children}
        </PopupHoverContainer>
    );
};

export default GAVerifiedTooltip;
